// extracted by mini-css-extract-plugin
export default {"title":"Faquestions_title__F5w4c","container":"Faquestions_container__Rbujx"};